import axios from 'axios';
import useTokenStore from '@store/token-store/token.store';
import useAuthStore from '@store/auth-store/auth.store.ts';
import { getApiBaseUrl } from '@shared/config/runtime-config';

const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (!config.baseURL) {
      config.baseURL = getApiBaseUrl();
    }

    const { accessToken } = useTokenStore.getState();
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      const currentPath = window.location.pathname;

      if (status === 401 && !currentPath.startsWith('/auth')) {
        const { logout } = useAuthStore.getState();
        logout();
      }
      console.warn(`[axios] ${status} error on ${currentPath}`, error.response);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
